import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom"; // Dodajte ovaj import
import MainCard from "components/layout/MainCard/MainCard";
import AnanlyticBlock from "./AnalyticBlock/AnalyticBlock";
import LoadingWrapper from "components/Loading/LoadingWrapper";
import icons from "helpers/icons";
import useAPI from "hooks/useAPI";
import { currencyFormat } from "helpers/functions";
import scss from "./AnalitycCard.module.scss";
import { useTranslation } from "react-i18next";

import DataTable from "components/DataTable/DataTable";
import SearchBar from "components/UI/SearchBar";
import PaginationUI from "../../components/UI/PaginationUI";
import tblFields from "./tblFields.json";

const AnalyticCardPage = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    const api = useAPI();
    const apiPath = "/analytics-card";
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(20);

    const [page, setPage] = useState(() => {
        const pageParam = searchParams.get("page");
        return pageParam ? parseInt(pageParam) : 1;
    });

    const [currentPage, setCurrentPage] = useState(1);

    const { data: dataSummary, isLoading: isLoadingSummary } = useQuery(["dataSummary"], () => api.get(apiPath + "/summary"));
    const {
        data: dataFinancialCard,
        isLoading: isLoadingFinancialCard,
        refetch: refetchFinancialCard,
    } = useQuery(["dataFinancialCard", page, limit], () => api.list(apiPath + "/financial-card/table", { search, page, limit }));
    const { data: dataFinancialCardLastTimeUpdate } = useQuery(["dataFinancialCardLastTimeUpdate"], () => api.get(apiPath + "/financial-card/last-time-update"));

    const description = t("global-analytic_card-description");
    const showTitle = description && description.trim().length > 0 && description !== "global-analytic_card-description";

    useEffect(() => setCurrentPage(dataFinancialCard?.pagination.selected_page ?? 1), [dataFinancialCard, page, dataFinancialCard?.pagination.selected_page]);

    useEffect(() => {
        refetchFinancialCard();
    }, [page, limit, search, refetchFinancialCard]);

    useEffect(() => {
        const newSearchParams = new URLSearchParams(searchParams);
        if (page === 1) {
            newSearchParams.delete("page");
        } else {
            newSearchParams.set("page", page.toString());
        }
        setSearchParams(newSearchParams);
    }, [page, searchParams, setSearchParams]);

    return (
        <MainCard>
            <div className="page-container">
                <div className={`p page-content`}>
                    <h4 className="h-underline">{t("global-analytic_card-title")}</h4>
                    {showTitle && <p>{description}</p>}
                    <LoadingWrapper isLoading={isLoadingSummary}>
                        <div className={scss.analyticsContainer}>
                            <AnanlyticBlock
                                title={t("global-analytic_card-product_thumb-balance")}
                                value={currencyFormat(dataSummary?.saldo, dataSummary?.currency)}
                                icon={icons.analytics}
                                background="blue"
                            />
                            <AnanlyticBlock
                                title={t("global-analytic_card-product_thumb-in_currency")}
                                value={currencyFormat(dataSummary?.debt_in_currency, dataSummary?.currency)}
                                icon={icons.analytics}
                                background="green"
                            />
                            <AnanlyticBlock
                                title={t("global-analytic_card-product_thumb-out_of_currency")}
                                value={currencyFormat(dataSummary?.debt_out_currency, dataSummary?.currency)}
                                icon={icons.analytics}
                                background="red"
                            />
                            <AnanlyticBlock title={t("global-analytic_card-product_thumb-approved_on")} value={dataSummary?.debt_days} icon={icons.analytics} background="yellow" />
                        </div>
                    </LoadingWrapper>
                    <LoadingWrapper isLoading={isLoadingFinancialCard}>
                        {dataFinancialCardLastTimeUpdate?.active && dataFinancialCard && dataFinancialCard?.items && dataFinancialCard?.items.length > 0 && (
                            <p style={{ marginTop: "1rem" }}>{dataFinancialCardLastTimeUpdate?.message}</p>
                        )}

                        {dataFinancialCard && dataFinancialCard?.items && dataFinancialCard?.items.length > 0 && <DataTable columns={tblFields} data={dataFinancialCard?.items} apiUrl={apiPath} />}
                    </LoadingWrapper>

                    {dataFinancialCard && dataFinancialCard?.pagination && dataFinancialCard?.pagination?.total_pages > 1 && (
                        <PaginationUI
                            activePage={currentPage}
                            setPage={setPage}
                            numberOfDisplayed={dataFinancialCard?.pagination?.items_per_page ?? 12}
                            numberOfProducts={dataFinancialCard?.pagination.total_items ?? 0}
                            changePage={() => {}}
                            page1={page}
                            setCurrentPage1={setPage}
                        />
                    )}
                </div>
            </div>
        </MainCard>
    );
};

export default AnalyticCardPage;
